import { useMetadataQuery } from '../../../../queries/useMetadataQuery';
import { useEffect } from 'react';

export const useMetadata = (
  datasetId: string,
  setDatasetIsOfflineWarningVisible: (item: boolean) => void,
  setAnalyticsDefinition: (item: any) => void
) => {
  const metadataQuery = useMetadataQuery(datasetId, true);

  useEffect(() => {
    if (metadataQuery.data) {
      if (metadataQuery.data.IsOffline) {
        setDatasetIsOfflineWarningVisible(true);
        return;
      }

      if (metadataQuery?.data.AnalyticsDefinition) {
        setAnalyticsDefinition(metadataQuery.data.AnalyticsDefinition);
      }
    }
  }, [metadataQuery?.data]);

  return {
    metadata: metadataQuery.data,
    loadingMetadata: metadataQuery.isLoading,
  };
};
